export default "__VITE_ASSET__CsUuX_P8__"